module.exports = __webpack_public_path__ + "static/media/success.8591f6af.svg";